import { CSSProperties } from '@material-ui/core/styles/withStyles';
import React from 'react';

interface IProps {
  color?: string;
  width?: number;
  height?: number;
  style?: CSSProperties;
}

const ChatstoryIcon = ({ color, width = 22, height = 20, style }: IProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={`0 0 22 20`}
    preserveAspectRatio={width !== 22 && height !== 20 ? 'none' : 'xMidYMid meet'}
  >
    <path
      fill={color || '#000'}
      fillRule="nonzero"
      d="M7.188 8.542c-2.585 0-4.688 1.681-4.688 3.75 0 1.114.63 2.175 1.697 2.885l-.425 1.062a.313.313 0 0 0 .43.395l1.55-.775c.468.121.95.183 1.435.183 2.585 0 4.687-1.682 4.687-3.75s-2.101-3.75-4.687-3.75zm10.312.312c0-2.585-2.453-4.687-5.469-4.687-2.434 0-4.44 1.365-5.138 3.363-.034.096-.06.266 0 .349.06.082.113.114.305.127C10 7.96 12.436 9.663 12.5 12.292c0 .27-.033.547-.098.824a.313.313 0 0 0 .34.381 6.246 6.246 0 0 0 1.386-.316l1.654.945a.313.313 0 0 0 .435-.411l-.646-1.293c1.23-.893 1.929-2.18 1.929-3.568z"
    />
  </svg>
);

export default ChatstoryIcon;
